"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _PagingModel2 = require("./PagingModel");

var _PagingModel3 = _interopRequireDefault(_PagingModel2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * model class of streets
 */

var SchoolHistoryModel = function (_PagingModel) {
    _inherits(SchoolHistoryModel, _PagingModel);

    function SchoolHistoryModel(observers, id, request) {
        _classCallCheck(this, SchoolHistoryModel);

        var _this = _possibleConstructorReturn(this, (SchoolHistoryModel.__proto__ || Object.getPrototypeOf(SchoolHistoryModel)).call(this, observers, id, request));

        _this.SchoolHistory = [];
        return _this;
    }

    _createClass(SchoolHistoryModel, [{
        key: "GetSchoolHistory",
        value: function GetSchoolHistory(sendData, start, limit) {
            var me = this;
            var req = "/Schools" + this.setSendData(sendData, start, limit);
            this.request.setRequest(req);
            this.request.setType("GET");
            this.request.setCallback(function (result) {
                if (result) {
                    if (result.Data) {
                        me.setResult(result);
                        if (result.Data.Data) {
                            me.SchoolHistory = result.Data.Data;
                        }
                    }
                }
                var id = me.Id ? me.Id : "SchoolHistory";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }]);

    return SchoolHistoryModel;
}(_PagingModel3.default);

exports.default = SchoolHistoryModel;